import { Action } from '@ngrx/store';
import { Settings } from '@app/core/_models/settings';

export enum CoreContextActionTypes {
  SET_COOKIE_TRACKING_CONSENT = '[CoreContext] Set cookie tracking',
  SET_COOKIE_TRACKING_CONSENT_HANDLED = '[CoreContext] Set cookie tracking handled',
  LOAD_SETTINGS = '[CoreContext] Load settings',
  SETTINGS_LOADED = '[CoreContext] Settings loaded',
}

export class SetCookieTrackingConsent implements Action {
  public readonly type = CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT;

  constructor(public enabled: boolean, public updateMember = true) {}
}

export class SetCookieTrackingConsentHandled implements Action {
  public readonly type = CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT_HANDLED;
}

/**
 * Starts settings loading. Should be called on app boot.
 */
export class LoadSettings implements Action {
  public readonly type = CoreContextActionTypes.LOAD_SETTINGS;
}

/**
 * Internal
 */
export class SettingsLoaded implements Action {
  public readonly type = CoreContextActionTypes.SETTINGS_LOADED;

  constructor(public settings: Settings | null) {}
}
